import { render } from "./serchIndex.vue?vue&type=template&id=5173d453"
import script from "./serchIndex.vue?vue&type=script&lang=js"
export * from "./serchIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__